<template>
  <div class="relative pb-6 bg-slate-100">
    <div class="py-4 px-6 flex">
      <BlTextBody2
        class="sticky left-94"
        :text="`Showing all ${totalAppointments} appointment(s)`"
      />
    </div>
    <div
      id="appointment-header"
      class="sticky top-46 flex rounded-t bg-slate-100"
      :style="{ zIndex: 11 }"
    >
      <div class="flex pl-6 bg-slate-100 sticky left-88 z-10">
        <div
          class="flex border-t border-l border-r border-slate-400 rounded-tl"
        >
          <div class="px-4 py-3 flex-shrink-0 bg-slate-200 w-20 rounded-tl">
            <BlTextSubtitle3 text="ID" class="text-slate-700" />
          </div>
          <div
            class="px-4 py-3 flex flex-shrink-0 bg-slate-200 w-60 rounded-tl"
          >
            <BlTextSubtitle3 text="Client name" class="text-slate-700" />
          </div>
        </div>
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
      >
        <BlTextSubtitle3 text="Status" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
      >
        <BlTextSubtitle3 text="Appointment date" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-40"
      >
        <BlTextSubtitle3 text="Timeslot" class="text-slate-700" />
      </div>
      <div
        v-if="enableBranch"
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
      >
        <BlTextSubtitle3 text="Branch" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
      >
        <BlTextSubtitle3 text="Room" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-50"
      >
        <BlTextSubtitle3 text="Assigned to" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-80"
      >
        <BlTextSubtitle3 text="Supervisor" class="text-slate-700" />
      </div>
      <div
        class="px-4 py-3 border-t border-slate-400 flex-shrink-0 bg-slate-200 w-80 flex-grow"
      >
        <BlTextSubtitle3 text="Reasons" class="text-slate-700" />
      </div>
      <div class="flex pr-6 bg-slate-100 sticky right-0 z-10">
        <div
          class="px-4 py-3 border-t border-r border-slate-400 rounded-tr flex-shrink-0 bg-slate-200 w-14"
        ></div>
      </div>
    </div>
    <AppointmentItem
      v-for="(appointment, idx) in appointments"
      :key="appointment.id"
      :appointment="appointment"
      :isLast="idx + 1 === appointments.length"
      @after-commit="$emit('after-commit')"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import AppointmentItem from "./Item.vue";

import BlTextSubtitle3 from "../../BlTextSubtitle3.vue";
import BlTextBody2 from "../../BlTextBody2.vue";

export default {
  name: "AppointmentsTable",
  components: {
    AppointmentItem,
    BlTextSubtitle3,
    BlTextBody2
  },
  props: {
    // @after-commit
  },
  computed: {
    ...mapGetters(["currentUser", "currentCenter", "appointments", "totalAppointments"]),
    enableBranch() {
      return this.currentCenter.enable_branch;
    }
  },
  created() {
    this.getCenterReasonSettings();
  },
  methods: {
    ...mapActions(["getCenterReasonSettings"])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/appointments/table/Table.vue